import { colors } from "./colors";
import { vars } from "./globalTheme.css";
import rgba from "polished/lib/color/rgba";

export const gradients = {
  blackMask: `linear-gradient(to bottom, black 0%, black 35%, transparent 100%)`,
  purpleToLightPurple: `linear-gradient(0deg, ${rgba(colors.purple800V2, 0.25)} 0%, ${rgba(colors.purple500V2, 0.25)} 100%)`,
  blueToPurple: `linear-gradient(to right, $blue500V2, $purple500V2)`,
  purpleToGreen: `linear-gradient(116.54deg, ${rgba(colors["outline-special-highlight"], 0.1)} 10.36%, ${rgba(colors["surface-primary-base"], 0.1)} 92.85%)`,
  darkGrayToGrayToDarkGray: `linear-gradient(-75deg, ${rgba(colors.neutral300, 0)} 0%, ${rgba(colors.neutral300, 0.3)} 51.28%, ${rgba(colors.neutral300, 0)} 100%)`,
  purpleToTeal: `linear-gradient(135deg, ${vars.colors["outline-special-highlight"]} 0%, ${colors.everWhite} 50%, ${vars.colors["outline-positive-subdue"]} 100%)`,
  radialPurpleToBlack: `radial-gradient(59.63% 59.63% at 50% 0%, ${rgba(colors["text-special-highlight"], 0.72)} 0%, ${rgba(colors["surface-neutral-subdue"], 0)} 100%), ${vars.colors["surface-neutral-base"]}`,
  radialGreyToGrey: `radial-gradient(circle farthest-side, ${colors.neutral300}, ${colors.neutral100})`,
  radialDarkGrayToDarkGray: `radial-gradient(circle farthest-side, ${colors.neutral700}, ${colors.neutral900})`,
  staticSkeleton: `linear-gradient(90deg, ${colors["surface-transparent-highlight"]} 0%, ${rgba(colors["surface-neutral-base"], 0)} 100%)`,
  skeleton: `linear-gradient(to right, ${vars.colors["surface-transparent-highlight"]} 0%, ${vars.colors["surface-transparent-base"]} 50%, ${vars.colors["surface-transparent-moreSubdue"]} 100%)`,
};

export const shadows = {
  onboardingPurpleBlur: `0px 0px 12px ${colors.purple600V2}`,
  purpleButtonBlur: `0px 0px 8px ${colors.purple600V2}`,
  onboardingCircleIconShadow: `4px 0px 4px 0px ${colors["neutral"]}`,
  focusShadow: `0px 0px 0px 1px ${vars.colors["outline-special-base"]}`,
  depthShadow: `0px 0px 32px 0px ${rgba(colors.everBlack, 0.2)}`,
};

export const blurFilters = {
  mostHighlight: "blur(24px)",
  moreHighlight: "blur(16px)",
  highlight: "blur(12px)",
  base: "blur(8px)",
};
